import type { Pages } from '@generated/graphql';
import { UserContext } from '@providers/userContextProvider';
import { useContext, useMemo } from 'react';

export const usePagePermission = (page: Pages) => {
  const { accessiblePages } = useContext(UserContext);

  return useMemo(() => accessiblePages.has(page), [accessiblePages, page]);
};
